// @module TavanoTeam.CategoryFacet.CategoryFacet
define('TavanoTeam.CategoryFacet.CategoryFacet.View'
,	[
		'tavanoteam_categoryfacet_categoryfacet.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		tavanoteam_categoryfacet_categoryfacet_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class TavanoTeam.CategoryFacet.CategoryFacet.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_categoryfacet_categoryfacet_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/CategoryFacet.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return TavanoTeam.CategoryFacet.CategoryFacet.View.Context
	,	getContext: function getContext()
		{
			//@class TavanoTeam.CategoryFacet.CategoryFacet.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
